import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import { t } from '../../../../../../modules/infra/i18n';
import * as shapes from '../../shapes';
import CustomReportMetric from './CustomReportMetric';

const CustomReportMetrics = ({
  selectedMetrics,
  availableMetrics,
  toggleMetricBreakdown,
  onMetricDrop,
  onSelectAll,
  onDeselectAll,
  onSelectMetric,
  onDeselectMetric,
}) => (
  <DragDropContext onDragEnd={onMetricDrop}>
    <div className="c-dragndrop-areas-layout u-mt+">
      <div className="c-dragndrop-area-column">
        <div className="c-label-new">{t('reports:custom_report_form.available_metrics')}</div>
        <Droppable droppableId="availableMetrics">
          {provided => (
            <div
              className="c-dragndrop-area-column__items"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {availableMetrics.map((metric, index) => (
                <CustomReportMetric
                  index={index}
                  key={metric.metricId}
                  metric={metric}
                  toggleMetric={onSelectMetric}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
      <div className="c-dragndrop-area__buttons">
        <button className="c-btn c-btn--small c-btn--white u-mv-" type="button" onClick={onSelectAll}>{'>>'}</button>
        <button className="c-btn c-btn--small c-btn--white u-mv-" type="button" onClick={onDeselectAll}>{'<<'}</button>
      </div>
      <div className="c-dragndrop-area-column">
        <div className="c-label-new">{t('reports:custom_report_form.selected_metrics')}</div>
        <Droppable droppableId="selectedMetrics">
          {provided => (
            <div
              className="c-dragndrop-area-column__items"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {selectedMetrics.map((metric, index) => (
                <CustomReportMetric
                  index={index}
                  key={metric.metricId}
                  metric={metric}
                  canToggleMetricBreakdown
                  toggleMetricBreakdown={toggleMetricBreakdown}
                  toggleMetric={onDeselectMetric}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </div>
  </DragDropContext>
);

CustomReportMetrics.propTypes = {
  selectedMetrics: shapes.reportMetrics.isRequired,
  availableMetrics: shapes.reportMetrics.isRequired,
  toggleMetricBreakdown: PropTypes.func.isRequired,
  onMetricDrop: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onDeselectAll: PropTypes.func.isRequired,
  onSelectMetric: PropTypes.func.isRequired,
  onDeselectMetric: PropTypes.func.isRequired,
};

export default CustomReportMetrics;
